import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import {
  showDefaultError,
  showError,
} from "src/app/shared/utils/functions/notification.function";
import Swal from "sweetalert2";

import { CognitoService } from "src/app/shared/services/cognito.service";
import { ModalValidateTokenComponent } from "src/app/portal/components/modal-validate-token/modal-validate-token.component";
import { ModalBloqueadorComponent } from "src/app/shared/components/modal-bloqueador/modal-bloqueador.component";
import { NavegadorCheckService } from "src/app/core/navegador-check.service";

@Component({
  selector: 'app-auth-investidor',
  templateUrl: './auth-investidor.component.html',
  styleUrls: ['./auth-investidor.component.scss']
})
export class AuthInvestidorComponent implements OnInit {
  mdbRef: MDBModalRef;
  tipoUsuario: string = "";
  formLogin: FormGroup;
  mostrarSenha = false;

  constructor(
    private cognitoService: CognitoService,
    private router: Router,
    private modalService: MDBModalService,
    private bloqueador: NavegadorCheckService
  ) {}

  ngOnInit() {
    this.formLogin = new FormGroup({
      documento: new FormControl("", [
        Validators.required,
        Validators.minLength(11),
      ]),
      senha: new FormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),
    });
  }

  openModal(){
      const permiteAcesso = this.bloqueador.NavegadorSuportado();

      if (!permiteAcesso) {
        const config = {
          ignoreBackdropClick: true,
          scroll: true
        }
        this.mdbRef = this.modalService.show(ModalBloqueadorComponent, config);
      } else {
        this.login();
      }
    }

  login() {
    if (this.formLogin.valid) {
      this.cognitoService
        .signIn(this.documento.value, this.senha.value)
        .subscribe(
          (res) => {
            switch (res) {
              case "":
                this.router.navigate(["spg"]);
                break;
              case "newPassword":
                this.router.navigate(["reset/senha"]);
                break;
              case "alertInvestidor":
                this.exibirAlertaInvestidor();
                break;
            }
          },
          (e) => {
            if (e.status == 400 || e.status == 422) return showDefaultError(e);

            if (e.name == "PasswordResetRequiredException") {
              Swal.fire({
                text: e.message,
                showConfirmButton: true,
                confirmButtonColor: '#303678',
                showCloseButton: true,
                icon: "error",
                iconColor: '#DC362E',
              }).then((result) => {
                if (result.isConfirmed || result.isDismissed) {
                  this.router.navigate(["reset/senha"]);
                }
              });
            } else if (e.name === 'UserNotConfirmedException') {
              Swal.fire({
                icon: "warning",
                iconColor: '#d97e03',
                title: "Confirme seu e-mail",
                text: "Seu cadastro foi criado. Agora confirme seu e-mail para ativar sua conta.",
                showCancelButton: true,
                confirmButtonColor: '#303678',
                cancelButtonColor: '#DC362E',
                confirmButtonText: "Confirmar email",
                cancelButtonText: "Cancelar",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.modalService.show(ModalValidateTokenComponent, {
                    data: {
                      username: this.documento.value,
                      modo: 'login'
                    }
                  });
                }
              })
            }
            else {
              showError("", e.message);
            }
          },
        );
    } else {
      if (this.senha.errors != null || this.senha.errors != undefined) {
        if (this.senha?.errors.strong || this.senha?.errors.minlength) {
          return showError(
            "",
            "Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 número.."
          );
        }
      }

      return showError(
        "",
        `O campo ${this.documento.value == "" ? "cpf" : "senha"} é obrigatório.`
      );
    }
  }

  cadastro() {
    const permiteAcesso = this.bloqueador.NavegadorSuportado();

    if (!permiteAcesso) {
      const config = {
        ignoreBackdropClick: true,
        scroll: true
      }
      this.mdbRef = this.modalService.show(ModalBloqueadorComponent, config);
    } else {
      return this.router.navigate(["/cadastro"]);
    }
  }

  resetSenha() {
    const permiteAcesso = this.bloqueador.NavegadorSuportado();

    if (!permiteAcesso) {
      const config = {
        ignoreBackdropClick: true,
        scroll: true
      }
      this.mdbRef = this.modalService.show(ModalBloqueadorComponent, config);
    } else {
      return this.router.navigate(["/reset/senha"]);
    }

  }


  private exibirAlertaInvestidor() {
    Swal.fire({
      title: "Este canal é exclusivo para Pessoa Jurídica!",
      html:
        "<p>Se deseja solicitar ou consultar o status de sua garantia de Pessoa Física " +
        "Pessoa Física, utilize o aplicativo <b>FGC</b>.</p>" +
        'Caso as dúvidas persistam, encaminhe um e-mail para <a href="mailto:atendimento.credores@fgc.org.br">atendimento.credores@fgc.org.br</a>',
      icon: "error",
      confirmButtonText: "ok",
    });
  }

  private get documento() {
    return this.formLogin.get("documento");
  }

  private get senha() {
    return this.formLogin.get("senha");
  }
}

